import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {L10nModule} from '../../components/translate';
import {AutofocusModule} from '../../directives/autofocus';
import {DynAuthWidgetBodyComponent} from '../components/dyn-auth-widget-body/dyn-auth-widget-body.component';
import {DexLpWidgetComponent} from './dex-lp-widget.component';
import {DEX_LP_WIDGET_DESCRIPTION} from './dex-lp-widget.description';
import {DexLpDetailsPartComponent} from './parts/dex-lp-details-part/dex-lp-details-part.component';
import {DexLpPartPlateComponent} from './parts/dex-lp-part-plate/dex-lp-part-plate.component';
import {DexTrancheDetailsPartComponent} from './parts/dex-tranche-details-part/dex-tranche-details-part.component';
import {DexLpWidgetSettingsComponent} from './settings/dex-lp-widget-settings.component';
import {DexLpWidgetSettingsService} from './settings/dex-lp-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        L10nModule,
        AutofocusModule,
        PartialLoadingIndicatorModule,
        DynAuthWidgetBodyComponent,
        DexLpDetailsPartComponent,
        DexTrancheDetailsPartComponent,
        DexLpPartPlateComponent
    ],
    declarations: [
        DexLpWidgetComponent,
        DexLpWidgetSettingsComponent
    ],
    exports: [
        DexLpWidgetComponent
    ],
    providers: [
        DexLpWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_LP_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexLpWidgetModule {}
